"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var client_lib_js_player_framework_utils_1 = require("@sky-uk-ott/client-lib-js-player-framework-utils");
var KEY_CODE_MAP = (_a = {},
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.UP] = [38],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.DOWN] = [40],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.LEFT] = [37],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.RIGHT] = [39],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.ENTER] = [13],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.BACK] = [8, 27],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.FF] = [117, 126],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.RW] = [116, 127],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.DELETE] = [32],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.PLAY] = [128],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.PAUSE] = [130],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.STOP] = [129],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_1] = [32],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_2] = [112],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_3] = [114, 119],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_4] = [116, 127],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_5] = [117, 126],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_6] = [120],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_7] = [118],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_9] = [112],
    _a);
var PREVENT_DEFAULT = new Set([38, 211, 203, 40, 212, 204, 37, 39, 8, 13, 27]);
var WebMafInput = (function (_super) {
    __extends(WebMafInput, _super);
    function WebMafInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.keyCodeMap = KEY_CODE_MAP;
        _this.preventDefault = PREVENT_DEFAULT;
        return _this;
    }
    return WebMafInput;
}(client_lib_js_player_addons_common_player_1.Input));
exports.WebMafInput = WebMafInput;
